export default "__VITE_ASSET__0PlI0f4H__"